module.exports = __webpack_public_path__ + "img/alentour13.b0f3ba0f.jpg";